import { fetchDataWithLoadMore, updateDocument } from "./helperAction";
import { toast } from "react-toastify";

export const fetchOrganizers = ({ status, lastVisible }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        const queryOptions = [
          { method: "orderBy", args: ["createdAt", "desc"] },
          { method: "where", args: ["role", "==", "organizer"] },
          { method: "where", args: ["status", "==", status] },
        ];

        const response = await fetchDataWithLoadMore({
          collectionName: "users",
          queryOptions,
          lastVisible,
        });

        dispatch({
          type: "FETCH_ORGANIZERS_SUCCESS",
          payload: response,
        });

        resolve(response);
      } catch (error) {
        toast.error(error.message || "Unable to fetch organizers");
        reject(error);
      }
    });
  };
};

export const updateOrganizerStatus = ({ id, status }) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        await updateDocument({
          collectionName: "users",
          docId: id,
          updateData: { status },
        });

        dispatch({
          type: "UPDATE_ORGANIZER_STATUS_SUCCESS",
          payload: { id, status },
        });

        toast.success("Organizer status updated successfully");
        resolve({ id, status });
      } catch (error) {
        toast.error(error.message || "Failed to update organizer status");
        reject(error);
      }
    });
  };
};
